export default __webpack_public_path__ + "static/media/uploadimg.b9e6fbb3.svg";